var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: {
        "modal-header": true,
        "modal-header--default": _vm.defaultHeader,
        "modal-header--dark": _vm.dark,
      },
    },
    [
      _vm._t("default", function () {
        return [
          _c("h4", {
            staticClass: "modal-title",
            domProps: { textContent: _vm._s(_vm.title) },
          }),
        ]
      }),
      _vm._v(" "),
      _vm.showCloseIcon
        ? _c(
            "button",
            {
              staticClass: "close",
              attrs: {
                "aria-label": "Close",
                "data-dismiss": "modal",
                type: "button",
              },
            },
            [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }